import React, { createContext, useState } from "react";

const UnitContext = createContext();

const UnitProvider = ({ children }) => {
  const [unit, setUnit] = useState("metric");

  const toggleUnit = (unit) => {
    if (unit) {
      setUnit(unit);
    } else {
      setUnit("metric");
    }
  };

  return (
    <UnitContext.Provider value={{ unit, toggleUnit }}>
      {children}
    </UnitContext.Provider>
  );
};

export { UnitProvider, UnitContext };
